/**
 * The floating assistant that sits on pages without the AppShell (the shell
 * pages surface the same conversation through the "Fragen" side panel
 * instead). A corner bubble that opens into a small panel; the conversation
 * itself lives in OverlayBotChat.
 */

import { useState } from "react";
import { useTranslation } from "react-i18next";
import { MessageCircle, X } from "lucide-react";

import OverlayBotChat, { OVERLAY_BOT_ACCENT } from "./OverlayBotChat";

export default function OverlayBot() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  if (!open) {
    return (
      <button
        type="button"
        onClick={() => setOpen(true)}
        aria-label={t("overlayBot.open")}
        className="fixed bottom-6 right-6 z-[1000] flex h-14 w-14 cursor-pointer items-center justify-center rounded-full border-0 text-white shadow-lg"
        style={{ backgroundColor: OVERLAY_BOT_ACCENT }}
      >
        {/* A speech bubble, not a question mark: the launcher should read as
            "talk to someone", which is what the panel behind it is. */}
        <MessageCircle aria-hidden="true" className="h-6 w-6" />
      </button>
    );
  }

  return (
    <div className="fixed bottom-6 right-6 z-[1000] flex h-[560px] max-h-[calc(100vh-3rem)] w-[360px] max-w-[calc(100vw-3rem)] flex-col overflow-hidden rounded-xl border bg-background shadow-2xl">
      <div
        className="flex items-center gap-3 px-4 py-3"
        style={{ backgroundColor: OVERLAY_BOT_ACCENT }}
      >
        <div className="min-w-0 flex-1">
          <div className="font-semibold text-white">{t("overlayBot.title")}</div>
          <div className="text-[11px] text-white/75">{t("overlayBot.subtitle")}</div>
        </div>
        <button
          type="button"
          onClick={() => setOpen(false)}
          aria-label={t("overlayBot.close")}
          className="cursor-pointer border-0 bg-transparent text-white/75 hover:text-white"
        >
          <X aria-hidden="true" className="h-4 w-4" />
        </button>
      </div>

      <OverlayBotChat active={open} />
    </div>
  );
}
